import { useEffect, useState } from "react";
import { HbrCancel, HbrShareIcon } from "../newComponents/Mycustomsvgicons";
import { shareHelper } from "../newComponents/GeneralClasses";



const ShareForm = ({message, url, title, formTitle, closeForm}) => {
    const [copied, setCopied] = useState(false);

    const handleCopyLink=async()=>{
        if(navigator.clipboard){
            try{
                await navigator.clipboard.writeText(`${message}\n\n${url}`);
                setCopied(true);
            }catch{
            }
        }
    };

    useEffect(()=>{
        if(copied){
            const timeid = setTimeout(() => {
                setCopied(false);
           }, 2000);

           return ()=>{
            clearTimeout(timeid);
           }
        }
    },[copied]);

    const handleMoreOptions=()=>{
        shareHelper(title, message, url);
        closeForm();
    };

    return ( 
        <div className="customshareform flex-column2">
            <div className="flex-spacearound" style={{width: "100%"}}>
                <h4>{formTitle}</h4>
            <HbrCancel width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>closeForm()}/>
            </div>
           
           <div style={{borderRadius:"30px", backgroundColor: "teal", width:"80%"}}>
            <p style={{fontWeight:"bold", padding:"10px", color:"white"}}>{message}</p>
           </div>
           

            <div className="flex-spacearound" style={{width:"100%"}}> 
                <h4 style={{width:"80%",overflow:"hidden"}}>
                    {url}
                </h4>
                <button onClick={()=>handleCopyLink()} style={{border:"none", backgroundColor:"#eb268f", borderRadius:"30px", fontWeight:"bold", color:"white", padding:"10px", cursor: "pointer"}}>
                    {`${!copied ? 'copy':'copied ✔'}`}
                </button>
                
            </div>

            <div className="flex-row2">
                <h4>More options</h4>
                <HbrShareIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>handleMoreOptions()}/>
            </div>
        </div>
     );
}
export default ShareForm;